import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const MyBallroomSection = () => {
  const [data, setData] = useState({
    title: "",
    description: "",
    appStoreUrl: "",
    googlePlayUrl: "",
    imagePath: "",
  });

  const fetchData = async () => {
    try {
      const response = await corefetch(
        "WelcomeSection/GetMyBallroomSectionList"
      );
      if (response && response.length > 0) {
        const sectionData = response[0];
        setData({
          title: sectionData.title,
          description: sectionData.description,
          appStoreUrl: sectionData.appStoreURL,
          googlePlayUrl: sectionData.playStoreURL,
          imagePath: sectionData.imagePath,
        });
      } else {
        setData([]);
        console.error("No data found");
      }
    } catch (error) {
      setData([]);
      console.error("Failed to fetch data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!data || data.length == 0) {
    return null;
  }

  return (
    <>
      {data && (
        <section className="wpo-about-section-s1 sec-padding">
          <div className="container">
            <div className="wpo-about-wrap">
              <div className="row">
                <div id="AboutMeridian" className="col-lg-6 col-md-12 col-12">
                  <div
                    className="wpo-about-text wow fadeInRightSlow"
                    data-wow-duration="1600ms"
                  >
                    <h2>{data.title}</h2>
                    <p>{data.description}</p>
                    <a href={data.appStoreUrl} target="_blank" tabIndex="0">
                      <img
                        className="bn46"
                        src="assets/images/Buttons/appStoreIcon.svg"
                        alt="App Store Icon"
                      />
                    </a>
                    <a href={data.googlePlayUrl} target="_blank" tabIndex="0">
                      <img
                        className="bn45"
                        src="assets/images/Buttons/GoogleplayButton.svg"
                        alt="Google Play Icon"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-12">
                  <div
                    className="wpo-about-item wow fadeInLeftSlow"
                    data-wow-duration="1500ms"
                  >
                    <div className="wpo-about-img about">
                      <img
                        src={`${ImageURL}${data.imagePath}`}
                        alt="Venue Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default MyBallroomSection;
